<template>
  <div :ref="chartRefId" :style="{ width: '100%', height: '400px' }"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'RadarChart',
  props: {
    dataInput: {
      type: Array,
      required: true
      // Example: [{ variable: 'Math', value: 85 }, { variable: 'Science', value: 92 }]
    }
  },
  data() {
    return {
      chartRefId: `radar-chart-${this._uid}`,
      chartInstance: null
    };
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      const chartEl = this.$refs[this.chartRefId];
      if (!chartEl) return;

      this.chartInstance = echarts.init(chartEl);

      const indicators = this.dataInput.map(item => ({
        name: item.variable,
        max: 100 // You can change this or compute based on data
      }));

      const values = this.dataInput.map(item => Number(item.value));

      const options = {
        title: {
          text: 'Radar Chart'
        },
        tooltip: {},
        radar: {
          indicator: indicators,
          radius: '65%'
        },
        series: [
          {
            name: 'Scores',
            type: 'radar',
            data: [
              {
                value: values,
                name: 'User'
              }
            ],
            areaStyle: { opacity: 0.2 },
            lineStyle: {
              color: '#FFD38A'
            },
            itemStyle: {
              color: '#D47900'
            }
          }
        ]
      };

      this.chartInstance.setOption(options);
      window.addEventListener('resize', this.resizeChart);
    },
    resizeChart() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    getChartInstance() {
      return this.chartInstance;
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resizeChart);
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }
};
</script>
